<template>
  <div
    class="tw-w-full tw-flex tw-flex-col tw-items-center tw-mt-6 xs:tw-mt-10"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ViewContainer',
}
</script>
